"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// from jquery port https://stackoverflow.com/a/42543908/196038
function getScrollParent(element, includeHidden) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

  if (style.position === "fixed") return document.body;
  /* eslint-disable */
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
  }
  /* eslint-enable */
  return document.body;
}

exports.default = getScrollParent;